module.exports = __webpack_public_path__ + "img/embedded2.4fb09e5b.png";